interface YourGiftCardPreviewProps {
  amount: number;
  recipientName?: string;
}

export function YourGiftCardPreview({ amount, recipientName }: YourGiftCardPreviewProps) {
  return (
    <div className="w-full">
      <p className="font-['DM_Sans',sans-serif] font-bold text-[#908e8e] text-[14px] tracking-[5px] uppercase mb-4">
        Your Gift card preview
      </p>

      {/* Gift Card Visual */}
      <div className="relative w-full h-[253px] bg-[#8e2a2f] rounded-[10px] overflow-hidden text-white">
        {/* Decorative circles */}
        <div className="absolute -top-10 -right-10 w-[165px] h-[165px] rounded-full bg-white/10" />
        <div className="absolute top-[170px] -left-[55px] w-[165px] h-[165px] rounded-full bg-white/10" />

        {/* Logo */}
        <div className="absolute top-[20px] left-[20px] flex items-center justify-between right-[20px]">
          <span className="font-['Playfair_Display',sans-serif] font-extrabold text-[18px] tracking-[2px] uppercase leading-none">
            Cherry<span className="block text-[9px] tracking-[6px] font-normal mt-1">Picked</span>
          </span>
          <span className="material-icons text-white/90 text-[24px]">card_giftcard</span>
        </div>

        {/* Amount */}
        <p className="absolute left-[20px] top-[80px] font-['Playfair_Display',sans-serif] font-extrabold text-[54px] leading-none tracking-[-0.5px]">
          £{amount || 0}
        </p>

        {/* Gift Card label */}
        <p className="absolute left-[20px] top-[145px] font-['DM_Sans',sans-serif] text-[14px] tracking-[5.9px] uppercase">
          gift Card
        </p>

        {/* Divider */}
        <div className="absolute left-[20px] right-[20px] top-[187px] h-px bg-white/30" />

        {/* For */}
        <div className="absolute left-[20px] top-[201px]">
          <p className="font-['DM_Sans',sans-serif] text-[12px] tracking-[-0.1px] opacity-90">For</p>
          <p className="font-['DM_Sans',sans-serif] font-bold text-[14px] tracking-[-0.1px] mt-1 truncate max-w-[260px]">
            {recipientName || 'Your Loved One'}
          </p>
        </div>
      </div>
    </div>
  );
}
